import * as React from 'react';
import { OfficeTemplatesScreen } from '../components/contracts.js';

/**
 * `/smlouvy-sablony` — Smlouvy a šablony (krok T3). Polozka menu existovala
 * uz z kroku O1 jako PRIPRAVUJE SE; tento krok ji naplnuje obsahem, stejne
 * jako FAK1 udelal s `/fakturace`.
 */
export function SmlouvySablonyPage(): React.JSX.Element {
  return <OfficeTemplatesScreen />;
}
